'use client'

import { FC, useId, useState } from 'react'

type ContentsDropdownProps = {
  titles: Array<{ text: string; id: string }>
}

export const ContentsDropdown: FC<ContentsDropdownProps> = ({ titles }) => {
  const [isOpen, setIsOpen] = useState(true)

  const id = useId()

  const headingId = `${id}-heading`
  const contentId = `${id}-content`

  return (
    <div>
      <button
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => {
          setIsOpen(prevState => !prevState)
        }}
        style={{ width: '100%', padding: 10 }}
      >
        <i
          style={{
            display: 'inline-block',
            transform: isOpen ? 'rotate(0)' : 'rotate(180deg)',
            transition: 'transform 500ms',
          }}
        >
          ▲
        </i>
        Inhalt
      </button>

      <div
        id={contentId}
        aria-labelledby={headingId}
        aria-hidden={!isOpen}
        style={{
          display: 'grid',
          gridTemplateRows: isOpen ? '1fr' : '0fr',
          transition: 'grid-template-rows 500ms',
        }}
      >
        <ul
          style={{
            overflow: 'hidden',
            listStyle: 'none',
            padding: '0 5px',
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
          }}
        >
          {titles.map(({ text, id }, index) => (
            <li key={id + index}>
              <a href={`#${id}`} tabIndex={!isOpen ? -1 : undefined}>
                {`${index + 1}. ${text}`}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
